// Утилиты для безопасности frontend

/**
 * Безопасное хранение токена в localStorage
 */
export const setSecureToken = (token: string): void => {
  try {
    localStorage.setItem('access_token', token);
  } catch (error) {
    console.error('Ошибка сохранения токена:', error);
  }
};

/**
 * Безопасное получение токена из localStorage
 */
export const getSecureToken = (): string | null => {
  try {
    return localStorage.getItem('access_token');
  } catch (error) {
    console.error('Ошибка получения токена:', error);
    return null;
  }
};

/**
 * Безопасное удаление токена
 */
export const removeSecureToken = (): void => {
  try {
    localStorage.removeItem('access_token');
  } catch (error) {
    console.error('Ошибка удаления токена:', error);
  }
};

/**
 * Проверка валидности токена (базовая проверка)
 */
export const isTokenValid = (token: string): boolean => {
  if (!token) return false;
  
  try {
    // Декодируем JWT токен (только payload)
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    
    // Проверяем срок действия
    return payload.exp > currentTime;
  } catch (error) {
    console.error('Ошибка проверки токена:', error);
    return false;
  }
};

/**
 * Очистка всех данных при выходе
 */
export const clearAllData = (): void => {
  try {
    localStorage.clear();
    sessionStorage.clear();
  } catch (error) {
    console.error('Ошибка очистки данных:', error);
  }
};

/**
 * Проверка на подозрительную активность
 */
export const detectSuspiciousActivity = (): boolean => {
  // Проверяем на множественные неудачные попытки
  const failedAttempts = localStorage.getItem('failed_login_attempts');
  const attempts = failedAttempts ? parseInt(failedAttempts) : 0;
  
  if (attempts >= 15) {
    console.warn('Обнаружено множество неудачных попыток входа');
    return true;
  }
  
  return false;
};

/**
 * Увеличение счетчика неудачных попыток
 */
export const incrementFailedAttempts = (): void => {
  const failedAttempts = localStorage.getItem('failed_login_attempts');
  const attempts = failedAttempts ? parseInt(failedAttempts) + 1 : 1;
  localStorage.setItem('failed_login_attempts', attempts.toString());
};

/**
 * Сброс счетчика неудачных попыток
 */
export const resetFailedAttempts = (): void => {
  localStorage.removeItem('failed_login_attempts');
};

/**
 * Проверка на XSS атаки в пользовательском вводе
 */
export const sanitizeInput = (input: string): string => {
  return input
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/\//g, '&#x2F;');
};

/**
 * Проверка на SQL injection в пользовательском вводе
 */
export const detectSQLInjection = (input: string): boolean => {
  const sqlPatterns = [
    /union\s+select/i,
    /drop\s+table/i,
    /insert\s+into/i,
    /delete\s+from/i,
    /update\s+set/i,
    /or\s+1\s*=\s*1/i,
    /';\s*drop/i,
  ];
  
  return sqlPatterns.some(pattern => pattern.test(input));
};

/**
 * Безопасная генерация CSRF токена
 */
export const generateCSRFToken = (): string => {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
};

/**
 * Проверка CSRF токена
 */
export const validateCSRFToken = (token: string, storedToken: string): boolean => {
  return token === storedToken && token.length === 64;
};
